/**
 * @file 产品标题
 * @author wangzhuang
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './index.less';

export default class Productitle extends Component {
    static propTypes = {
        title: PropTypes.string,
        className: PropTypes.string
    };

    render() {
        return (
            <div className={classnames('product-title mui-flex align-center', this.props.className)}>
                <div className={'text'}>{this.props.title}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ProductTitle/index.js